export default "__VITE_ASSET__C6PLB447__"